import { Starter } from '#GameFrontend/unauthorized/types/Starter';
import { StarterFormGeneProps } from '#GameFrontend/unauthorized/types/StarterForm';

export function createGeneByBloodline(gene: StarterFormGeneProps, bloodline: Starter): StarterFormGeneProps {
	if (bloodline.starterGenes.black.value) {
		gene.base = 'black';
		gene.dun = bloodline.mustHaveGenes.black.dun.value;
		gene.cream = bloodline.mustHaveGenes.black.cream.value;
	} else if (bloodline.starterGenes.bay.value) {
		gene.base = 'bay';
		gene.dun = bloodline.mustHaveGenes.bay.dun.value;
		gene.cream = bloodline.mustHaveGenes.bay.cream.value;
	} else {
		gene.base = 'chestnut';
		gene.dun = bloodline.mustHaveGenes.chestnut.dun.value;
		gene.cream = bloodline.mustHaveGenes.chestnut.cream.value;
	}

	gene.grey = bloodline.mustHaveGenes.grey;

	gene.tobiano = bloodline.mustHaveGenes.tobiano;
	gene.overo = bloodline.mustHaveGenes.overo;
	gene.leopard = bloodline.mustHaveGenes.leopard;

	gene.marks.head = bloodline.mustHaveGenes.marks.head;
	gene.marks.leg = bloodline.mustHaveGenes.marks.leg;

	return gene;
}

export function generateFilenameByGene(gene: StarterFormGeneProps, isMale: boolean): string {
	const base = gene.grey ? 'grey' : gene.base;
	const dun = gene.dun && !gene.grey ? '_dun' : '';
	const cream = gene.cream && !gene.grey ? '_cream' : '';
	const pattern = gene.leopard ? '_leopard' : gene.tobiano ? '_tobiano' : gene.overo ? '_overo' : '';
	const mark_head = gene.marks.head ? '_head' : '';
	const mark_leg = gene.marks.leg ? '_leg' : '';
	const gender = isMale ? 'male' : 'female';
	return `${base}${dun}${cream}${pattern}${mark_head}${mark_leg}_${gender}`;
}
